import {
	AlertDialog,
	AlertDialogClose,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogPopup,
	AlertDialogTitle,
} from './ui/alert-dialog';
import { Alert, AlertDescription } from './ui/alert';
import { Button } from './ui/button';
import { Info } from 'lucide-react';
import { useState } from 'react';

const SuspendDialog = () => {
	const [open, setOpen] = useState(true);
	return (
		<AlertDialog open={open} onOpenChange={setOpen}>
			<AlertDialogPopup className="max-w-[450px]">
				<AlertDialogHeader>
					<AlertDialogTitle>บัญชีของคุณถูกระงับการใช้งาน</AlertDialogTitle>
					<AlertDialogDescription className="sr-only">รายละเอียดการระงับบัญชี</AlertDialogDescription>
				</AlertDialogHeader>
				<Alert className="mx-6 mb-6 w-auto" variant="error">
					<Info />
					<AlertDescription>
							ขณะนี้บัญชีของคุณถูกระงับการใช้งาน
							<div className="mt-2">
								คุณยังสามารถเข้าถึงข้อมูลของคุณได้ แต่ไม่สามารถดาวน์โหลดสคริปต์หรือใช้บริการอื่น ๆ ได้
							</div>

							<div className="mt-2">
								สอบถามข้อมูลเพิ่มเติมได้ที่ <a href="https://cfx.errorism.co/discord" target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">Discord</a> ของเรา
							</div>
					</AlertDescription>
				</Alert>
				<AlertDialogFooter>
					<AlertDialogClose render={<Button type="button" variant="destructive" />}>
						รับทราบ
					</AlertDialogClose>
				</AlertDialogFooter>
			</AlertDialogPopup>
		</AlertDialog>
	);
};

export default SuspendDialog;
